import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  stockIds: [],
}

// sliceを生成
export const bookmarks = createSlice({
  name: 'bookmark',
  initialState,
  reducers: {
    get_bookmark: (state, action) => {
      return {
        ...state,
        stockIds: action.payload,
      }
    },
    updateBookmark: (state, action) => {
      const ids = [...state.stockIds];
      if (ids.includes(action.payload)) {
        ids.splice(ids.indexOf(action.payload), 1);
      } else{
        ids.push(action.payload);
      }
      return {
        ...state,
        stockIds: ids,
      }
    },
  },
})

export const { get_bookmark, updateBookmark } = bookmarks.actions
export default bookmarks.reducer
